var _rect, _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.98877,
    width: 88,
    height: 87.0112,
    rx: 12,
    fill: "url(#paint0_linear_1722_668)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1722_668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1032 63.9998C60.6765 63.9998 58.5485 63.4585 56.7192 62.3758C54.8898 61.2931 53.4712 59.8558 52.4632 58.0638C51.4552 56.2718 50.9512 54.2931 50.9512 52.1278V24.7998H60.3592V52.7998C60.3592 53.6958 60.6765 54.4798 61.3112 55.1518C61.9458 55.8238 62.7298 56.1598 63.6632 56.1598H74.0232V63.9998H63.1032Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1722_668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.416 63.9998V24.7998H32.272C34.8853 24.7998 37.2747 25.3971 39.44 26.5918C41.6427 27.7865 43.3973 29.4478 44.704 31.5758C46.0107 33.6665 46.664 36.0931 46.664 38.8558C46.664 41.6185 46.0107 44.0825 44.704 46.2478C43.3973 48.3758 41.6614 50.0371 39.496 51.2318C37.3307 52.4265 34.9227 53.0238 32.272 53.0238H24.824V63.9998H15.416ZM24.824 45.1278H31.208C32.328 45.1278 33.336 44.8851 34.232 44.3998C35.128 43.9145 35.856 43.2051 36.416 42.2718C36.976 41.3385 37.256 40.2185 37.256 38.9118C37.256 37.6051 36.976 36.4851 36.416 35.5518C35.856 34.6185 35.1094 33.9091 34.176 33.4238C33.28 32.9011 32.2907 32.6398 31.208 32.6398H24.824V45.1278Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1722_668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9512 21.7998H63.3592V52.7998C63.3592 52.8852 63.3726 52.9207 63.378 52.9342C63.3841 52.9494 63.4073 53.0021 63.4922 53.0919C63.5244 53.126 63.5451 53.1418 63.5528 53.1473C63.5548 53.1487 63.5564 53.1497 63.5574 53.1504C63.5593 53.1509 63.5625 53.1517 63.5672 53.1526C63.58 53.1551 63.6104 53.1598 63.6632 53.1598H77.0232V66.9998H63.1032C60.2164 66.9998 57.5456 66.351 55.1912 64.9575C52.9244 63.6159 51.1238 61.8019 49.8484 59.5346C48.5743 57.2694 47.9512 54.7799 47.9512 52.1278V21.7998ZM56.7192 62.3758C58.5485 63.4585 60.6765 63.9998 63.1032 63.9998H74.0232V56.1598H63.6632C62.7298 56.1598 61.9458 55.8238 61.3112 55.1518C60.6765 54.4798 60.3592 53.6958 60.3592 52.7998V24.7998H50.9512V52.1278C50.9512 54.2931 51.4552 56.2718 52.4632 58.0638C53.4712 59.8558 54.8898 61.2931 56.7192 62.3758Z",
    fill: "black",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1722_668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.416 66.9998V21.7998H32.272C35.3588 21.7998 38.2479 22.5099 40.8798 23.9599C43.5356 25.4023 45.674 27.426 47.2546 29.9963C48.8897 32.6172 49.664 35.605 49.664 38.8558C49.664 42.1126 48.8873 45.122 47.2726 47.7978L47.2666 47.8077L47.2605 47.8176C45.6852 50.3832 43.5695 52.4107 40.9452 53.8585C38.3044 55.3156 35.392 56.0238 32.272 56.0238H27.824V66.9998H12.416ZM24.824 53.0238H32.272C34.9227 53.0238 37.3307 52.4265 39.496 51.2318C41.6614 50.0371 43.3974 48.3758 44.704 46.2478C46.0107 44.0825 46.664 41.6185 46.664 38.8558C46.664 36.0931 46.0107 33.6665 44.704 31.5758C43.3974 29.4478 41.6427 27.7865 39.44 26.5918C37.2747 25.3971 34.8853 24.7998 32.272 24.7998H15.416V63.9998H24.824V53.0238ZM32.7273 36.0519L32.6644 36.0151C32.2477 35.7721 31.7837 35.6398 31.208 35.6398H27.824V42.1278H31.208C31.8796 42.1278 32.3883 41.9866 32.8032 41.7619C33.1945 41.5499 33.5404 41.2336 33.8435 40.7283C34.0724 40.3469 34.256 39.7842 34.256 38.9118C34.256 38.0394 34.0724 37.4767 33.8435 37.0953C33.5584 36.62 33.2158 36.3059 32.792 36.0855L32.7273 36.0519ZM24.824 45.1278V32.6398H31.208C32.2907 32.6398 33.28 32.9011 34.176 33.4238C35.1094 33.9091 35.856 34.6185 36.416 35.5518C36.976 36.4851 37.256 37.6051 37.256 38.9118C37.256 40.2185 36.976 41.3385 36.416 42.2718C35.856 43.2051 35.128 43.9145 34.232 44.3998C33.336 44.8851 32.328 45.1278 31.208 45.1278H24.824Z",
    fill: "black",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1722_668",
    x: 47.9512,
    y: 23.7998,
    width: 33.0718,
    height: 49.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1722_668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1722_668",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1722_668",
    x: 12.416,
    y: 23.7998,
    width: 41.248,
    height: 49.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1722_668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1722_668",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1722_668",
    x: 44.9512,
    y: 20.7998,
    width: 39.0718,
    height: 55.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1722_668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1722_668",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1722_668",
    x: 9.41602,
    y: 20.7998,
    width: 47.248,
    height: 55.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1722_668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1722_668",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1722_668",
    x1: 44,
    y1: 0.98877,
    x2: 44,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C7DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4258F7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlLogo);
export default __webpack_public_path__ + "static/media/pl_logo.af4ed09440adda4498462d5f7b85e852.svg";
export { ForwardRef as ReactComponent };